import { Button, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import { VariationSelection } from "../../../common/types/apiTypes";
import { AutocompleteType } from "../../../common/types/autoComplete";
import { reasonForTemporaryEmploymentOptions } from "../constants";
import { OrderTesVariation } from "../orderTesVariation/OrderTesVariation";
import { OrderFields } from "../orderTypes";
import { OrderFieldsProperties } from "./types";

// TODO: We get a warning in console related to the Tes Type
// should probably fix the warning.
// MUI: The value provided to Autocomplete is invalid.

type Props = {
  values: OrderFields;
  handleChangeCallback: (
    name: OrderFieldsProperties,
    newValue:
      | AutocompleteType[]
      | AutocompleteType
      | Date
      | null
      | number
      | string
      | boolean,
  ) => void;
  onTesVariationChange: (variation: VariationSelection[]) => void;
};

const Terms = ({
  values,
  handleChangeCallback,
  onTesVariationChange,
}: Props) => {
  const [tesSettingsOpen, setTesSettingsOpen] = useState(false);
  const { t } = useTranslation(["order", "common"]);

  const { tes } = useAppSelector((state) => state.localized);
  const tesId = values.orderTemplate.tes?.id || null;

  return (
    <>
      <Grid container item xs={4} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">
          {t("order:reasonForTemporaryEmployment")}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <TextField
          select
          fullWidth
          sx={{
            backgroundColor: "rgba(249, 249, 250, 0.6)",
            width: "363px",
          }}
          size="small"
          name="reasonForTemporaryEmployment"
          value={values.reasonForTemporaryEmployment}
          onChange={(e) => {
            handleChangeCallback(
              "reasonForTemporaryEmployment",
              e.target.value,
            );
          }}
        >
          {reasonForTemporaryEmploymentOptions
            .sort((a, b) => t(a.label).localeCompare(t(b.label)))
            .map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {t(option.label)}
              </MenuItem>
            ))}
        </TextField>
      </Grid>
      <Grid container item xs={4} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("common:tes")}</Typography>
      </Grid>
      <Grid container item xs={8} alignItems="center">
        <Grid item container>
          <TextField
            disabled
            size="small"
            select
            value={tesId}
            sx={{ width: "363px" }}
          >
            <MenuItem value={tesId || ""}>{tesId ? tes[tesId] : ""}</MenuItem>
          </TextField>
          <Button
            sx={{ textTransform: "none", marginLeft: "0.5rem" }}
            variant="text"
            disabled={!tesId}
            onClick={() => setTesSettingsOpen(true)}
          >
            {t("common:settingsDots")}
          </Button>
        </Grid>
      </Grid>
      <OrderTesVariation
        variationDefaults={values.orderTemplate.tesVariation}
        tesId={tesId || ""}
        date={values.date}
        open={tesSettingsOpen}
        onClose={() => setTesSettingsOpen(false)}
        setTesVariation={onTesVariationChange}
      />
    </>
  );
};

export default Terms;
